<template>
  <div class="ui grid" v-if="!isGuest">
    <div class="row">
      <h1 class="ui huge header">{{ stage ? stage.title : 'Cooperative Learning Links' }}</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row" v-if="stage">
      <div class="sixteen wide column">
        <p>{{ stage.intro }}</p>

        <div class="unit" v-for="unit in stage.units" :key="unit.number">
          <h3 class="ui header">Unit {{ unit.number }} &mdash; {{ unit.sticker }}</h3>
          <ul>
            <li v-for="(link, i) in unit.links" :key="i">
              <a :href="link.url" target="_blank" rel="noopener">
                <i class="large file video icon"></i>{{ link.label }}
              </a>
            </li>
          </ul>
          <p class="note" v-for="(note, i) in unit.notes" :key="`n${i}`">{{ note }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { findNode } from '@/data/resources';
import stages from '@/data/cooperativeLearningStages';

// Renders one Cooperative Learning "Stage" page: the Unit -> link tables transcribed
// from the Word documents in docs/stories/update-resource-links/.
export default {
  name: 'CooperativeLearningStage',
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    isGuest() {
      return this.user && this.user.profile && this.user.profile.role === 'Guest';
    },
    stage() {
      const node = findNode(this.$route.path);
      return node && node.stageKey ? stages[node.stageKey] : null;
    },
  },
  created() {
    this.$store.dispatch('hideLoader');
  },
};
</script>

<style scoped>
.unit {
  margin-bottom: 1.5em;
}

.unit ul {
  margin-top: 0.3em;
}

.unit .note {
  margin: 0.2em 0 0 1.2em;
  color: #555;
}
</style>



// WEBPACK FOOTER //
// src/components/resources/CooperativeLearningStage.vue